/**
 * Colors dictionary for hex values
 * @type {Object}
 * @property {string} primary #00458C
 * @property {string} secondary - #00AEEF
 * @property {string} success - #4CAF50
 * @property {string} error - #D6562A
 * @property {string} warning - #F4A427
 * @property {string} info - #E2C757
 * @property {string} light - #FFFFFF
 * @property {string} dark - #231F20
 * @property {string} white - #FFFFFF
 * @property {string} black - #231F20
 * @property {string} gray - #D9D9D6
 * @example
 * // Use a color
 * const primaryColor = Colors.primary; // "#00458C"
 */
export const Colors = {
  primary: "#00458C",
  secondary: "#00AEEF",
  success: "#4CAF50",
  error: "#D6562A",
  warning: "#F4A427",
  info: "#E2C757",
  light: "#FFFFFF",
  dark: "#231F20",
  white: "#FFFFFF",
  black: "#231F20",
  gray: "#D9D9D6",
};
